import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { MenuAction } from '../../core/model/menu/menu-action.model';


@Injectable({
  providedIn: 'root'
})
export class MainMenuService {

  private menuSubject = new Subject<MenuAction>();

  constructor() { }

  public click(): void {
    this.menuSubject.next(MenuAction.toggle)
  }

  public close(): void {
    this.menuSubject.next(MenuAction.close)
  }

  public subscribe(fn: (loading: MenuAction) => void): Subscription {
    return this.menuSubject.subscribe(fn)
  }

  

}
